import React from 'react';
import classes from './Growth.module.css';
import IntentionsMockup1 from 'assets/images/app-mock-ups/intentions1.png';
import IntentionsMockup2 from 'assets/images/app-mock-ups/intentions2.png';
import GrowthInCommunity from 'assets/images/GrowthInCommunity.png';
import SendFeedback from 'components/UI/SendFeedback/SendFeedback';

const Growth = () => {
  return (
    <div className={classes.Container}>
      <h1 className={classes.ComingSoon}>Coming Soon</h1>
      <div className={classes.GrowthInCommunityContainer}>
        <h1>Growth-in-Community</h1>
        <p>Become your best self with the help of others</p>
        <img src={GrowthInCommunity} alt="growth-in-community" />
      </div>
      <div className={classes.AppIntentions}>
        <div className={classes.AppMockUps}>
          <img src={IntentionsMockup1} alt="intentions-1" />
          <img src={IntentionsMockup2} alt="intentions-1" />
        </div>
        <p>You can use your iPhone to try Intentions, one of Riza’s Growth features, now. Be sure to check it out!</p>
      </div>
      <SendFeedback />
    </div>
  );
};

export default Growth;
